import React from 'react'

function ContactPage() {
  return <p>Hello</p>
}

export default ContactPage
